'use client';

import { SettingsProvider } from '@/components/minimal-components/settings';
import SnackbarProvider from '@/components/minimal-components/snackbar/snackbar-provider';
import { LocalizationProvider } from '@/locales';
import '@/locales/i18n';
import TranslationProvider from '@/locales/translation-provider';
import ThemeProvider from '@/themes';
import '@/themes/globals.css';
import dynamic from 'next/dynamic';
import { Noto_Sans_Thai } from 'next/font/google';
import { useEffect } from 'react';

const GlobalErrorDialog = dynamic(() => import('@/components/utils/global-error-dialog'), {
  ssr: false,
});

const notoSansThai = Noto_Sans_Thai({
  subsets: ['thai'],
  variable: '--font-noto-sans-thai',
});

type Props = {
  children: React.ReactNode;
};

export default function RootLayout({ children }: Props) {
  // ปิด log ในโหมด production
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      console.log = function () {};
      console.warn = function () {};
      console.info = function () {};
      console.error = function () {};
      console.table = function () {};
    }
  }, []);

  return (
    <html lang="en">
      <body className={`${notoSansThai.variable}`}>
        <TranslationProvider>
          <LocalizationProvider>
            <SettingsProvider
              defaultSettings={{
                themeMode: 'light',
                themeDirection: 'ltr',
                themeContrast: 'default',
                themeLayout: 'vertical',
                themeColorPresets: 'cyan',
                themeStretch: false,
              }}
            >
              <ThemeProvider>
                <SnackbarProvider>
                  <GlobalErrorDialog />
                  <main>{children}</main>
                </SnackbarProvider>
              </ThemeProvider>
            </SettingsProvider>
          </LocalizationProvider>
        </TranslationProvider>
      </body>
    </html>
  );
}
